import { ED_MODAL_EVENTS } from '@/plugins/ed-modal/ed-modal.plugin';

export default {
  name: 'ed-modal-container',
  data: () => {
    return {
      component: null,
      confirmation: null,
      modalMessage: null,
      params: {},
      confirmParams: {},
      modalMessageParams: {},
      mounted: false,
      shown: false,
      lastModal: 0,
      onFront: false,
      moreParams: {}
    }
  },
  computed: {
    classes() {
      return { 'ed-modal-container--shown': this.shown, 'ed-modal-container--on-front': this.onFront  }
    }
  },
  methods: {
    show() {
      this.mounted = true;
      setTimeout(() => {
        this.shown = true;
      }, 100);
    },
    hide() {
      this.shown = false;
      setTimeout(() => {
        this.mounted = false;
        this.component = null;
        this.confirmation = null;
        this.modalMessage = null;
        this.onFront =  false;
      }, 300);
    },
    closeMessageModal() {
      this.modalMessage = null;
      this.onFront =  false;
      this.verifyModals();
    },
    closeConfirmationModal() {
      this.confirmation = null;
      this.onFront =  false;
      this.verifyModals();
    },
    verifyModals() {
      if(!this.confirmation && !this.component) {
        this.$EdModal.closeModal();
      }
    }
  },
  created() {
    this.$EdModal.$on(ED_MODAL_EVENTS.ED_CREATE_MODAL, ({modalMessageParams, modalMessage, modal, params, confirmation, confirmParams, moreParams }) => {
      if(modalMessage) {
        this.modalMessage = modalMessage;
        this.modalMessageParams = modalMessageParams;
        this.lastModal = 0;
        this.onFront = modalMessageParams?.onFront || false;
      }
      if(modal) {
        this.component = modal;
        this.params = params;
        this.moreParams = moreParams;
        this.lastModal = 1;
      }
      if(confirmation) {
        this.confirmation = confirmation;
        this.confirmParams = confirmParams;
        this.lastModal = 2;
        this.onFront = confirmParams.onFront || false;
      }
      this.show();
    });
    this.$EdModal.$on(ED_MODAL_EVENTS.ED_MODAL_CONFIRMATION_HIDE, this.closeConfirmationModal);
    this.$EdModal.$on(ED_MODAL_EVENTS.ED_MODAL_MESSAGE_HIDE, this.closeMessageModal);
    this.$EdModal.$on(ED_MODAL_EVENTS.ED_MODAL_HIDE, this.hide);
    this.$EdModal.$on(ED_MODAL_EVENTS.ED_MODAL_CHANGE_BODY, body => {
      switch(this.lastModal){
        case 0:
          this.modalMessageParams.body = body;
        break;
        case 1:
          this.params.body = body;
        break;
        case 2:
          this.confirmParams.body = body;
        break;
      }
    });
  },
  destroyed() {
    this.moreParams = {};
  }
};